module.exports = __webpack_public_path__ + "img/disappointment.43b82da3.svg";